/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Hide/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputIcon from 'DesignSystem/TysiaInput/TysiaInputIcon/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaVisibility from 'DesignSystem/Svgs/TysiaVisibility/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Hide({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Details/Ssn/Hide",
  isInvalid,
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newRelationPersonSsnValueData = fromData.useDataFormat({ viewPath,
context: 'new_relation',
path: 'person.ssn',
format: fromHelpers.socialSecurityNumberHide,
})
let newRelationPersonSsnIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'person.ssn',
validate: fromValidate.social_security_number,
})
let newRelationPersonSsnChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.ssn',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Hide.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 data="new_relation.person.ssn"
 validate="/Data/validate.js social_security_number"
 format="helpers.js socialSecurityNumberHide"
 invalid={!newRelationPersonSsnIsValidData}
 value={newRelationPersonSsnValueData}
 onChange={newRelationPersonSsnChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputIcon
{...childProps}
  viewPath={`${viewPath}/TysiaInputIcon`}
>
{childProps => (
<button
  data-testid="Hide.Horizontal:1"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Show'))}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="SSN"
/>
<TysiaVisibility
  viewPath={`${viewPath}/TysiaVisibility`}
 width={dtSpaceM}
 height={dtSpaceM}
 stroke="rgb(0,150,89)"
/>
</button>
)}
</TysiaInputIcon>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}